import React from 'react';

const FIELDS = [
  { key: 'full_name', type: 'text', placeholder: 'Jane Doe', maxLength: 120, required: true },
  { key: 'firm_name', type: 'text', placeholder: 'Doe & Partners LLP', maxLength: 150 },
  { key: 'email', type: 'email', placeholder: 'jane@doelaw.com', maxLength: 254, required: true },
  { key: 'phone', type: 'tel', placeholder: '(555) 123-4567', maxLength: 40 },
];

export const DemoRequestForm = ({ request, copy, offer }) => <>
  <h3 data-testid="demo-request-offer" className="text-xl font-bold text-slate-900">{copy.formTitle}</h3>
  <p data-testid="demo-required-fields-note" className="mt-1.5 text-sm text-slate-500">{copy.formSubtitle}</p>
  <form onSubmit={request.submit} className="mt-7 space-y-5" data-testid="demo-form">
    {FIELDS.map(field => <div key={field.key}>
      <label htmlFor={`demo-field-${field.key}`} className="mb-1.5 block text-sm font-medium text-slate-700">{copy.labels[field.key]}</label>
      <input type={field.type} id={`demo-field-${field.key}`} required={field.required} maxLength={field.maxLength}
        value={request.form[field.key]} onChange={request.update(field.key)} placeholder={field.placeholder}
        className="w-full rounded-lg border border-slate-200 bg-white px-4 py-3 text-[15px] text-slate-800 outline-none transition-colors placeholder:text-slate-400 focus:border-blue-400 focus:ring-2 focus:ring-blue-100"
        data-testid={`demo-input-${field.key}`} />
    </div>)}
    <button type="submit" disabled={request.submitting} className="w-full rounded-lg bg-blue-700 px-6 py-3.5 text-[15px] font-semibold text-white shadow-sm transition-colors duration-200 hover:bg-blue-800 disabled:opacity-60" data-testid="demo-submit-button">{request.submitting ? copy.submitting : copy.submit}</button>
    <p data-testid="demo-consent-disclaimer" className="text-center text-xs text-slate-400">{copy.disclaimer}</p>
    <p className="demo-request-boundary" data-testid="demo-request-boundary">{offer.requestNote}</p>
    <p className="demo-request-boundary" data-testid="demo-email-status">{offer.emailNote}</p>
    {request.error && <p className="error-message" role="alert" data-testid="demo-request-error">{request.error}</p>}
  </form>
</>;